/**
 * Chart color tokens (P0 admin kit). Every value is a `var(--g-*)` string so
 * Recharts passes it straight to an SVG stroke/fill attribute and dark mode
 * re-resolves automatically (no JS theme plumbing). See _shared/KIT-SPEC.md.
 */
export const CHART = {
  axis: "var(--g-ink-3)",
  grid: "var(--g-hairline)",
  primary: "var(--g-primary)",
  accent: "var(--g-accent)",
  success: "var(--g-success)",
  warn: "var(--g-warn)",
  error: "var(--g-error)",
  surface: "var(--g-surface)",
  ink: "var(--g-ink)",
  ink2: "var(--g-ink-2)",
} as const;

/** Default multi-series palette (used by Distribution/Split when no per-datum tone). */
export const CHART_SERIES: readonly string[] = [
  CHART.primary,
  CHART.accent,
  CHART.success,
  CHART.warn,
  CHART.error,
];

export type ChartTone = "primary" | "accent" | "success" | "warn" | "error" | "neutral";

/** Maps a semantic tone to its chart color string. `neutral` → axis ink. */
export function toneColor(tone: ChartTone): string {
  switch (tone) {
    case "primary":
      return CHART.primary;
    case "accent":
      return CHART.accent;
    case "success":
      return CHART.success;
    case "warn":
      return CHART.warn;
    case "error":
      return CHART.error;
    case "neutral":
      return CHART.ink2;
  }
}
